
import { Box, alpha } from '@mui/material';
import { ReactNode } from 'react';
import { BrandColors } from '@neumind/shared/branding';

// Default color fallback
const DEFAULT_COLOR = BrandColors.primary.main;

export interface FeatureIconProps {
    icon: ReactNode;
    color?: string;
    variant?: 'circle' | 'square';
    size?: 'small' | 'medium' | 'large' | 'xlarge';
    sx?: any;
}

const SIZES = {
    small: { box: 32, icon: 16 },
    medium: { box: 48, icon: 24 },
    large: { box: 64, icon: 32 },
    xlarge: { box: 80, icon: 40 },
};

export function FeatureIcon({
    icon,
    color = DEFAULT_COLOR,
    variant = 'circle',
    size = 'large', // Default matches previous 'medium' (64px)
    sx,
}: FeatureIconProps) {
    const dimensions = SIZES[size];

    return (
        <Box
            sx={{
                width: dimensions.box,
                height: dimensions.box,
                borderRadius: variant === 'circle' ? '50%' : 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: alpha(color, 0.1),
                color: color,
                '& svg': { fontSize: dimensions.icon },
                ...sx,
            }}
        >
            {icon}
        </Box>
    );
}
